module.exports = __webpack_public_path__ + "img/patent.7a251dcf.png";